<div ng-controller="organizationToolsController as ctrl">
    <c-simple-list configuration="ctrl.listConfig" items="ctrl.tools"></c-simple-list>
    <ui-view></ui-view>
</div>